import namespacedSelector from '../helpers/selectors/namespacedSelector'
import { createSelector } from 'reselect'

const selector = namespacedSelector('token')

export const getAccessToken = selector('accessToken')
export const isAccessTokenValid = createSelector([getAccessToken], (token) => {
  return !!token
})
